





































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as user from "../../_store/user.module";
import { InstituteInfo } from "../../_models/instituteInfo";
import { AreaInfo } from "../../_models/areaInfo";
import { bus } from "../../main";
import * as auth from "../../_store/auth.module";
import { userUtils } from "../../_utils/userUtils";
import * as data from "../../_store/data.module";
import { AziendaAreaInfo } from "../../_models/aziendaAreaInfo";
import { AllievoAreaInfo } from "../../_models/allievoAreaInfo";
import StudentSchedule from "../../components/DataTables/StudentSchedule.vue";
import { Calendar } from "../../_models/calendar";
import * as temp from "../../_store/temp.module"

@Component({
  components: {
    CardTitle,
    StudentSchedule
  }
})
export default class GestioneProgettoCV extends Vue {
  private aEnergia: string[];
  private sEnergia: string[];
  private aLength: number;
  private sLength: number;
  private titleParams: object;
  private hours: number;
  private duration: number;
  private areeList: AreaInfo[];
  private calendars: any;
  private articolazioni: any;
  private articolazioneSelezionata: string;
  private idIstituto: number;
  private showSchedule: boolean;

  private aziendetmp: number[];
  private studentitmp: number[];

  constructor() {
    super();
    this.titleParams = {
      title: "PROGETTO CV",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "4"
    };
    // this.aEnergia = ["a1", "a2", "a3", "a4", "a5"];
    // this.sEnergia = ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8"];
    this.aEnergia = [
      "a1",
      "a2",
      "a3",
      "a4",
      "a5",
      "a6",
      "a7",
      "a8",
      "a9",
      "a10",
      "a11",
      "a12",
      "a13",
      "a14",
      "a15",
      "a16",
      "a17",
      "a18"
    ];
    this.sEnergia = [
      "s1",
      "s2",
      "s3",
      "s4",
      "s5",
      "s6",
      "s7",
      "s8",
      "s9"
      // "s10",
      // "s11",
      // "s12",
      // "s13",
      // "s14",
      // "s15",
      // "s16",
      // "s17",
      // "s18"
      // "s19",
      // "s20",
      // "s21",
      // "s22",
      // "s23",
      // "s24",
      // "s25",
      // "s26",
      // "s27"
    ];
    this.aLength = this.aEnergia.length;
    this.sLength = this.sEnergia.length;
    this.hours = 4;
    this.duration = 20;
    this.areeList = [];
    this.calendars = [];
    this.articolazioni = [];
    this.articolazioneSelezionata = "";
    this.idIstituto = 0;
    this.showSchedule = false;

    this.aziendetmp = [450,83,704,351]
    this.studentitmp = [150,282,785,706,201,151,152,226,707,154,205,793,880]
  }

  get nTurns() {
    var n = (this.hours * 60) / this.duration;
    return n;
  }

  get nMinTurns() {
    if (this.aLength < this.sLength) {
      return this.sLength / this.aLength;
    } else {
      return this.aLength / this.sLength;
    }
  }

  get nIdealTurns() {
    if (this.aLength < this.sLength) {
      return this.sLength;
    } else {
      return this.aLength;
    }
  }

  @Watch("articolazioneSelezionata")
  onIndirizzoChange(value: string) {
    this.areeList = [];
    this.loadAree(this.idIstituto, value);
  }

  test() {
    var calendar: string[][] = [];

    var tmpCalendar: string[][] = [];
    var idle: number = 0;
    var turns: number = this.nTurns;
    var s: number = 0;
    if (this.aLength > 0 && this.sLength > 0) {
      for (let r = 0; r < this.aLength; r++) {
        calendar[r] = [];
        for (let c = 0; c < this.nTurns; c++) {
          calendar[r][c] = "";
        }
      }
      if (this.aLength < this.sLength) {
        idle = this.sLength / this.aLength;
        // for (let r = 0; r < this.aLength; r++) {
        //   calendar[r] = [];
        //   for (let c = 0; c < this.nTurns; c++) {
        //     calendar[r][c] = "";
        //   }
        // }
        if (idle > 7) {
          turns = idle;
        }
        for (let i = 0; i < turns; i++) {
          for (let j = 0; j < this.aLength; j++) {
            let exist = true;
            for (let n = 0; n < this.sLength && exist; n++) {
              exist = this.checkExistTest(calendar[j], i, this.sEnergia, s);
              if (exist) {
                if (s < this.sLength - 1) {
                  s++;
                } else {
                  s = 0;
                }
              }
            }
            if (exist) {
              calendar[j][i] = "0";
            } else {
              calendar[j][i] = this.sEnergia[s];
              if (s < this.sLength - 1) {
                s++;
              } else {
                if (idle > 7) {
                  // exist = true
                  j = this.aLength;
                }
                s = 0;
              }
            }
          }
        }
      } else {
        idle = this.aLength / this.sLength;
        for (let r = 0; r < this.sLength; r++) {
          tmpCalendar[r] = [];
          for (let c = 0; c < turns; c++) {
            tmpCalendar[r][c] = "";
          }
        }
        for (let i = 0; i < turns; i++) {
          for (let j = 0; j < this.sLength; j++) {
            let exist = true;
            for (let n = 0; n < this.aLength && exist; n++) {
              exist = this.checkExistTest(tmpCalendar[j], i, this.aEnergia, s);
              if (exist) {
                if (s < this.aLength - 1) {
                  s++;
                } else {
                  s = 0;
                }
              }
            }
            if (exist) {
              tmpCalendar[j][i] = "0";
            } else {
              tmpCalendar[j][i] = this.aEnergia[s];
              if (s < this.aLength - 1) {
                s++;
              } else {
                if (idle > 4) {
                  // exist = true
                  j = this.sLength;
                }
                s = 0;
              }
            }
          }
        }
        //passaggio a matrice calendar
        for (let a = 0; a < this.aLength; a++) {
          for (let i = 0; i < this.sLength; i++) {
            for (let j = 0; j < turns; j++) {
              if (tmpCalendar[i][j] === this.aEnergia[a]) {
                calendar[a][j] = this.sEnergia[i];
              }
            }
          }
        }
        // console.log(tmpCalendar);
      }
    }
    // console.log(calendar);
  }

  back() {
    this.showSchedule = false;
    this.calendars = [];
  }

  calculate() {
    for (let a = 0; a < this.areeList.length; a++) {
      // console.log(this.areeList[a].idArea);
      // console.log(this.areeList[a].aziendeArea);
      // console.log(this.areeList[a].studentiArea);
      this.calculateCalendar(
        this.areeList[a].aziendeArea,
        this.areeList[a].studentiArea,
        a
      );
      // console.log(this.calendar);
    }
    this.showSchedule = true;
    // var calendar: string[][] = [];
    // var s: number = 0;
    // if (this.aLength > 0 && this.sLength > 0) {
    //   if (this.aLength < this.sLength) {
    //     for (let r = 0; r < this.aLength; r++) {
    //       calendar[r] = [];
    //       for (let c = 0; c < this.nTurns; c++) {
    //         calendar[r][c] = "";
    //       }
    //     }
    //     for (let i = 0; i < this.nTurns; i++) {
    //       for (let j = 0; j < this.aLength; j++) {
    //         let exist = true;
    //         for (let n = 0; n < this.sLength && exist; n++) {
    //           exist = this.checkExist(calendar[j], i, this.sEnergia, s);
    //           if (exist) {
    //             if (s < this.sLength - 1) {
    //               s++;
    //             } else {
    //               s = 0;
    //             }
    //           }
    //         }
    //         if (exist) {
    //           calendar[j][i] = "0";
    //         } else {
    //           calendar[j][i] = this.sEnergia[s];
    //           if (s < this.sLength - 1) {
    //             s++;
    //           } else {
    //             s = 0;
    //           }
    //         }
    //       }
    //     }
    //   } else {
    //     for (let r = 0; r < this.sLength; r++) {
    //       calendar[r] = [];
    //       for (let c = 0; c < this.nTurns; c++) {
    //         calendar[r][c] = "";
    //       }
    //     }
    //     for (let i = 0; i < this.nTurns; i++) {
    //       for (let j = 0; j < this.sLength; j++) {
    //         let exist = true;
    //         for (let n = 0; n < this.aLength && exist; n++) {
    //           exist = this.checkExist(calendar[j], i, this.aEnergia, s);
    //           if (exist) {
    //             if (s < this.aLength - 1) {
    //               s++;
    //             } else {
    //               s = 0;
    //             }
    //           }
    //         }
    //         if (exist) {
    //           calendar[j][i] = "0";
    //         } else {
    //           calendar[j][i] = this.aEnergia[s];
    //           if (s < this.aLength - 1) {
    //             s++;
    //           } else {
    //             s = 0;
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
    // console.log(calendar);
  }

  calculateCalendar(
    aziende: AziendaAreaInfo[],
    studenti: AllievoAreaInfo[],
    areaIndex: number
  ) {
    var az: number[] = [];
    var stu: number[] = [];
    var s: number = 0;
    var calendar: number[][] = [];
    var tmpCalendar: number[][] = [];
    var idle: number = 0;
    var turns: number = this.nTurns;
    var schedule: {
      idAzienda: number;
      assegnazioni: number[];
    };
    var objCalendar: Calendar = {
      idArea: 0,
      nomeArea: "",
      schedules: []
    };

    for (let x = 0; x < aziende.length; x++) {
      az.push(aziende[x].idAzienda);
    }
    for (let y = 0; y < studenti.length; y++) {
      stu.push(studenti[y].idAllievo);
    }

    if (az.length > 0 && stu.length > 0) {
      for (let r = 0; r < az.length; r++) {
        calendar[r] = [];
        for (let c = 0; c < this.nTurns; c++) {
          calendar[r][c] = 0;
        }
      }
      if (az.length < stu.length) {
        idle = stu.length / az.length;

        // for (let r = 0; r < az.length; r++) {
        //   calendar[r] = [];
        //   for (let c = 0; c < this.nTurns; c++) {
        //     calendar[r][c] = 0;
        //   }
        // }
        if (idle >= 7) {
          turns = idle;
        }
        for (let i = 0; i < turns; i++) {
          for (let j = 0; j < az.length; j++) {
            let exist = true;
            for (let n = 0; n < stu.length && exist; n++) {
              exist = this.checkExist(calendar[j], i, stu, s);
              if (exist) {
                if (s < stu.length - 1) {
                  s++;
                } else {
                  s = 0;
                }
              }
            }
            if (exist) {
              calendar[j][i] = 0;
            } else {
              calendar[j][i] = stu[s];
              if (s < stu.length - 1) {
                s++;
              } else {
                if (idle >= 3) {
                  // exist = true
                  j = az.length;
                }
                s = 0;
              }
            }
          }
        }
      } else {
        idle = az.length / stu.length;
        for (let r = 0; r < stu.length; r++) {
          tmpCalendar[r] = [];
          for (let c = 0; c < turns; c++) {
            tmpCalendar[r][c] = 0;
          }
        }
        for (let i = 0; i < turns; i++) {
          for (let j = 0; j < stu.length; j++) {
            let exist = true;
            for (let n = 0; n < az.length && exist; n++) {
              exist = this.checkExist(tmpCalendar[j], i, az, s);
              if (exist) {
                if (s < az.length - 1) {
                  s++;
                } else {
                  s = 0;
                }
              }
            }
            if (exist) {
              tmpCalendar[j][i] = 0;
            } else {
              tmpCalendar[j][i] = az[s];
              if (s < az.length - 1) {
                s++;
              } else {
                if (idle >= 3) {
                  // exist = true
                  j = stu.length;
                }
                s = 0;
              }
            }
          }
        }

        //passaggio a matrice calendar
        for (let a = 0; a < az.length; a++) {
          for (let i = 0; i < stu.length; i++) {
            for (let j = 0; j < turns; j++) {
              if (tmpCalendar[i][j] === az[a]) {
                calendar[a][j] = stu[i];
              }
            }
          }
        }
        // console.log(tmpCalendar);
      }
    }
    // console.log(az)
    // console.log(stu)
    // console.log(calendar);
    objCalendar.idArea = this.areeList[areaIndex].idArea;
    objCalendar.nomeArea = this.areeList[areaIndex].descrizioneArea;
    // objCalendar.schedules = [{
    //   idAzienda: 0,
    //   assegnazioni: []
    // }]
    // schedule.assegnazioni = []
    schedule = {
      idAzienda: 0,
      assegnazioni: []
    };
    for (let r = 0; r < az.length; r++) {
      schedule.idAzienda = az[r];
      if (calendar[r] !== undefined) {
        for (let c = 0; c < calendar[r].length; c++) {
          schedule.assegnazioni[c] = calendar[r][c];
        }
        objCalendar.schedules.push({
          idAzienda: az[r],
          assegnazioni: calendar[r]
        });
      }
    }

    // console.log(objCalendar);
    this.calendars.push(objCalendar);
  }

  // checkExist(
  //   calendar: string[],
  //   column: number,
  //   array: string[],
  //   s: number
  // ): boolean {
  //   for (let i = 0; i < column; i++) {
  //     if (calendar[i] === array[s]) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  checkExist(
    calendar: number[],
    column: number,
    array: number[],
    s: number
  ): boolean {
    for (let i = 0; i < column; i++) {
      if (calendar[i] === array[s]) {
        return true;
      }
    }
    return false;
  }

  checkExistTest(
    calendar: string[],
    column: number,
    array: string[],
    s: number
  ): boolean {
    for (let i = 0; i < column; i++) {
      if (calendar[i] === array[s]) {
        return true;
      }
    }
    return false;
  }

  minTurns(aLength: number, sLength: number) {
    if (aLength < sLength) {
      return sLength / aLength;
    } else {
      return aLength / sLength;
    }
  }

  idealTurns(aLength: number, sLength: number) {
    if (aLength < sLength) {
      return sLength;
    } else {
      return aLength;
    }
  }

  loadAree(idIstituto: number, idArticolazione: string) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var payload = {
      idIstituto: idIstituto
    };
    data
      .dispatchAreeIstituto(this["$store"], payload)
      .then(resp => {
        resp.forEach(element => {
          var area: AreaInfo;
          var payload3 = {
            idArea: 0,
            idArticolazione: idArticolazione,
            idAnnoScolastico: idAnnoScolastico
          };
          area = {
            idArea: element.idArea,
            descrizioneArea: element.descrizioneArea,
            studentiArea: [],
            aziendeArea: [],
            nMinTurni: 0,
            nIdealTurni: 0
          };
          area.idArea = element.idArea;
          area.descrizioneArea = element.descrizioneArea;
          payload3.idArea = element.idArea;

          data
            .dispacthAllieviArea(this["$store"], payload3)
            .then(risp => {
              // console.log("allievo");
              area.studentiArea = risp;
              data
                .dispatchAziendeArea(this["$store"], payload3)
                .then(res => {
                  // console.log("azienda");
                  area.aziendeArea = res;
                  // console.log(res);
                  area.nMinTurni = this.minTurns(
                    area.aziendeArea.length,
                    area.studentiArea.length
                  );
                  area.nIdealTurni = this.idealTurns(
                    area.aziendeArea.length,
                    area.studentiArea.length
                  );

                  this.areeList.push(area);
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });

          // data
          //   .dispacthAllieviArea(this["$store"], payload3)
          //   .then(risp => {
          //     area.studentiArea = risp;
          //   })
          //   .catch(error => {
          //     if (error.response.status === 403) {
          //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          //       this["$router"].push("/login");
          //     } else {
          //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          //     }
          //   });
          // data
          //   .dispatchAziendeArea(this["$store"], payload3)
          //   .then((res: any) => {
          //     area.aziendeArea = res;
          //   })
          //   .catch(error => {
          //     if (error.response.status === 403) {
          //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          //       this["$router"].push("/login");
          //     } else {
          //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          //     }
          //   });

          // area.nMinTurni = this.minTurns(
          //   area.aziendeArea.length,
          //   area.studentiArea.length
          // );
          // area.nIdealTurni = this.idealTurns(
          //   area.aziendeArea.length,
          //   area.studentiArea.length
          // );
          // console.log(area);
          // this.areeList.push({
          //   idArea: area.idArea,
          //   descrizioneArea: area.descrizioneArea,
          //   studentiArea: area.studentiArea,
          //   aziendeArea: area.aziendeArea,
          //   nMinTurni: area.nMinTurni,
          //   nIdealTurni: area.nIdealTurni
          // });
          // this.areeList.push(area)
        });

        // console.log(this.areeList);
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  save() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var idAzienda: number;
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var idIstituto = instituteInfo.id;
    var turn: number;
    var idAllievo: number;
    var scheduleArray: number[];
    var payload = {
      idAllievo: 0,
      idAzienda: 0,
      idIstituto: idIstituto,
      idAnnoScolastico: idAnnoScolastico,
      idArticolazione: this.articolazioneSelezionata,
      nTurno: 0
    };
    this.calendars.forEach((calendar: any) => {
      if (calendar.schedules.length > 0) {
        // idAzienda = calendar.schedules.idAzienda;
        // payload.idAzienda = idAzienda;
        // console.log(i)
        // console.log(calendar);
        // console.log(calendar.schedules);
        // console.log(calendar.schedules[i].idAzienda);
        calendar.schedules.forEach((schedule: any) => {
          // console.log(schedule)
          idAzienda = schedule.idAzienda;
          payload.idAzienda = idAzienda;
          scheduleArray = schedule.assegnazioni.slice();
          // console.log(payload.idAzienda);
          scheduleArray.forEach((element, index) => {
            if (element !== 0) {
              // console.log(element);
              // console.log(index);
              payload.idAllievo = element;
              payload.nTurno = index + 1;
              // console.log(payload.idAzienda)
              user
                .dispatchRegisterSchedule(this["$store"], payload)
                // .then(() => {

                // })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
            }
          });
        });

        // scheduleArray = calendar.schedules.assegnazioni.slice();

        // scheduleArray.forEach(element => {
        //   console.log(element);
        // });
      }
    });
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    var payload2 = {
      idIstituto: 0
    };
    // var payload3 = {
    //   idArea: 0
    // };
    var studentiArea: any = [];
    var aziendeArea: any = [];
    var nMinTurni: number = 0;
    var nIdealTurni: number = 0;
    var idArea: number = 0;
    var descrizioneArea: string = "";
    var articolazione = {
      idArticolazione: "",
      nomeArticolazione: ""
    };
    var articolazioni: any[] = [];
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            var instituteInfo = user.readInstituteInfo(this["$store"]);
            this.idIstituto = instituteInfo.id;
            payload2.idIstituto = instituteInfo.id;

            data
              .dispatchArticolazioni(this["$store"], instituteInfo.id)
              .then(risp => {
                risp.forEach((element: any) => {
                  articolazione = {
                    idArticolazione: element.idArticolazione,
                    nomeArticolazione: element.nomeArticolazione
                  };
                  articolazioni.push(articolazione);
                });
                this.articolazioni = articolazioni;

                // this.loadAree(instituteInfo.id)
                bus.$emit("loadMenu");
              })
              .catch(() => {
                bus.$emit("stopLoading");
                auth.dispatchLogout(this["$store"]);
                user.dispatchClearState(this["$store"]);
                this["$router"].push("/sessionExpired");
              });
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });
  }
}
